import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

/** Ajoute le cookie de session sur les appels API. Aucun token côté front. */
export const authInterceptor: HttpInterceptorFn = (req, next) =>
  next(req.url.startsWith(environment.apiBaseUrl) ? req.clone({ withCredentials: true }) : req);
